import {Scrollbars} from "react-custom-scrollbars-2";
import React, {useEffect, useState} from "react";
import SummaryButton from "../atoms/SummaryButton";
import {useSelector} from "react-redux";
import useMainNavigation from "./useMainNavigation";
import SectionTabButtons from "../molecules/SectionTabButtons";
import NavigationList from "../molecules/NavigationList";

const OptionNavigator = ({slideToSubHandler}) => {
  const navData = useSelector(state => state.menuOpen.navData);
  const langData = useSelector(state => state.theme.langData);
  const isManualScrolling = React.useRef(false);

  const {summaryButtonClickHandler, navRef, scrollbarsRef} = useMainNavigation();

  const [currentNaviTab, setCurrentNaviTab] = useState("EXT");


  const handleNaviTab = (type) => {
    isManualScrolling.current = true;
    setCurrentNaviTab(type);

    const firstMatchingIndex = navData.processedNavData?.findIndex(
      (navItem) => navItem.cameraType === type
    );

    if (firstMatchingIndex !== -1 && navRef.current[firstMatchingIndex]?.current) {
      const targetElement = navRef.current[firstMatchingIndex].current;
      const scrollTop = targetElement.offsetTop;

      scrollbarsRef.current?.scrollTop(scrollTop);
    }
  };

  const handleScroll = (values) => {
    if (isManualScrolling.current) return;

    const { scrollTop, scrollHeight, clientHeight } = values;
    
    const isAtBottom = (scrollHeight - clientHeight) - scrollTop <= 2;

    const firstIntIndex = navData.processedNavData?.findIndex(
      (item) => item.cameraType === "INT"
    );

    if (firstIntIndex !== -1 && navRef.current[firstIntIndex]?.current) {
      const intThreshold = navRef.current[firstIntIndex].current.offsetTop;

      if (isAtBottom || scrollTop >= intThreshold) {
        if (currentNaviTab !== "INT") setCurrentNaviTab("INT");
      } else {
        if (currentNaviTab !== "EXT") setCurrentNaviTab("EXT");
      }
    }
  };

  const handleScrollStop = () => {
    isManualScrolling.current = false;
  };


  return (
    <div className={"option-container"} style={{display: "flex", flexDirection: "column", height: "100%"}}>
      <SectionTabButtons
        handleNaviTab={handleNaviTab}
        currentNaviTab={currentNaviTab}
      />
      <div className={"scrollable-area"}>
        <Scrollbars
          autoHide
          ref={scrollbarsRef}
          onScrollFrame={handleScroll}
          onScrollStop={handleScrollStop}
        >
          <NavigationList
            navData={navData}
            langData={langData}
            navRef={navRef}
            slideToSubHandler={slideToSubHandler}
          />
          <SummaryButton onClick={summaryButtonClickHandler}/>
        </Scrollbars>
      </div>

    </div>
  );
}

export default OptionNavigator;
